import type { IconSvgObject } from './types';

const RankingIcon: IconSvgObject = [
  ["path", { d: "M3 22V16C3 15.4477 3.44772 15 4 15H8C8.55228 15 9 15.4477 9 16V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 22V18C15 17.4477 15.4477 17 16 17H20C20.5523 17 21 17.4477 21 18V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 22V14C9 13.4477 9.44772 13 10 13H14C14.5523 13 15 13.4477 15 14V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 22H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M9.21885 10L12 8.54499L14.7812 10L14.16 7.07823L16.5 5.05573L13.335 4.70499L12 2L10.6651 4.70499L7.5 5.05573L9.84 7.07823L9.21885 10Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default RankingIcon;
